import { Nav, NavDropdown } from "react-bootstrap";
import { useAppDispatch, useAppSelector } from "../../context-store";
import { menuActions } from "../../context-store/menu-context";
import styles from "./Header.module.css";
import authenticationService from "../../services/authentication-service";
import { authActions } from "../../context-store/auth-context";
import toasterUtils from "../../utils/toaster-utils";
import UserDropDownImage from "../../assets/InnerCSS/img/avatars/user-dropdown.jpg";
import { useHistory } from "react-router";
import companyDashboardService from "../../services/company/dashboard-service";
import CompanyLogoModel from "../../models/company/dashboard/response/CompanyLogoModel";
import { useEffect, useState } from "react";
import { RoleEnum } from "../../models/enums/RoleEnum";

const Header = () => {
  const history = useHistory();
  let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
  const dispatch = useAppDispatch();
  const [companyLogo, setCompanyLogo] = useState<CompanyLogoModel | null>(null);

  useEffect(() => {
    if (loggedInUser && (parseInt(loggedInUser.roleId) === parseInt(RoleEnum.ClientAdmin.toString()) || parseInt(loggedInUser.roleId) === parseInt(RoleEnum.ClientLead.toString())
      || parseInt(loggedInUser.roleId) === parseInt(RoleEnum.ClientRecruiter.toString()) || parseInt(loggedInUser.roleId) === parseInt(RoleEnum.Vendor.toString())
      || parseInt(loggedInUser.roleId) === parseInt(RoleEnum.VendorRecruiter.toString()))) {
      getCompanyLogo();
    }
  }, []);

  const expanseCollapseHandler = () => {
    dispatch(menuActions.toggleSideBarStatus());
  };
  const logOutHandler = () => {
    authenticationService.logOut().then(() => {
      dispatch(authActions.logout());
      history.push("/login");
    }).catch(error => {
      toasterUtils.showError('Unable to logout user!');
    });
  };

  const getCompanyLogo = () => {
    companyDashboardService.getCompanyLogo().then((res) => {
      setCompanyLogo(res.data);
    }).catch(error => {
      toasterUtils.showError('Unable to logout user!');
    });
  }

  const changePasswordHandler = () => {
    history.push("/changepassword");
  }

  let UserName = "";
  let DefaultRole = "";
  let TimeZone = "";
  let LastLogin;
  let date;
  //let roles = [];

  if (loggedInUser != null) {
    UserName = loggedInUser.name;
    DefaultRole = loggedInUser.roleName;
    const today = new Date();
    LastLogin = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).format(today)
    LastLogin = LastLogin.replaceAll('/', '-')
  }
  let searchBarClass = `${styles.searchAlign} form-control mr-sm-1`;
  let HeaderBarClass = `${styles.headerAlign} navbar navbar-expand-md navbar-dark`;

  return (
    <div className="page-header">
      <div className="search-form">
        <form>
          <div className="input-group">
            <input type="text" name="search" className="form-control search-input" placeholder="Type something..."></input>
            <span className="input-group-btn">
              <button className="btn btn-default" id="close-search" type="button"><i className="icon-close"></i></button>
            </span>
          </div>
        </form>
      </div>
      <nav className="navbar navbar-default">
        <div className="container-fluid">
          <div className="navbar-header">
            <div className="logo-sm">
              <a id="sidebar-toggle-button" onClick={expanseCollapseHandler}><i className="fa fa-bars"></i></a>
              {companyLogo &&
                <img className="logo-box header-logo-company" src={`data:image/png;base64,${companyLogo.companyLogo}`} alt="Company Logo" />
              }
              {/* <a className="logo-box"><span>IAI</span></a> */}
            </div>
            <NavDropdown className="mob-nav-logout"
              title={
                <span style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                  {/* <img src={UserDropDownImage} className="rounded-circle" style={{ marginRight: "8px" }} /> */}
                  <span className={styles.userAlign}>{UserName ? UserName.charAt(0).toUpperCase() : ''}</span>
                </span>
              }
              id="bs-example-navbar-collapse-1"
            >
              <NavDropdown.Item className="dropdown-item">{UserName}</NavDropdown.Item>
              <NavDropdown.Divider className="dropdown-item" />
              <NavDropdown.Item className="dropdown-item" onClick={changePasswordHandler}>Change Password</NavDropdown.Item>
              <NavDropdown.Item className="dropdown-item" onClick={logOutHandler}>Log Out</NavDropdown.Item>
            </NavDropdown>
          </div>
          <div className="collapse navbar-collapse">
            <ul className="nav navbar-nav">
              <li><a id="collapsed-sidebar-toggle-button" onClick={expanseCollapseHandler}><i className="fa fa-bars"></i></a></li>
              {companyLogo &&
                <img className="header-logo-company" src={`data:image/png;base64,${companyLogo.companyLogo}`} alt="Company Logo" />
              }
            </ul>
            <ul className="nav navbar-nav navbar-right">
              <NavDropdown
                title={
                  <span className="user-name-nav">
                    {/* <span className={styles.userAlign}>{UserName}</span> */}
                    {UserName ? UserName.charAt(0).toUpperCase() : ''}
                  </span>
                }
                id="bs-example-navbar-collapse-1"
              >
                <NavDropdown.Item className="dropdown-item">{UserName}</NavDropdown.Item>
                <NavDropdown.Divider className="dropdown-item" />
                <NavDropdown.Item className="dropdown-item" onClick={changePasswordHandler}>Change Password</NavDropdown.Item>
                <NavDropdown.Item className="dropdown-item" onClick={logOutHandler}>Log Out</NavDropdown.Item>
              </NavDropdown>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};
export default Header; 